<template>
  <img
    class="m-20px w-full"
    :class="alignment"
    :src="image.image"
    :alt="image.description" />
</template>

<script>
import { computed } from "vue";
import { useCustomValidator } from "../../compostables/useValidators";

export default {
  props: {
    image: {
      type: Object,
      required: true,
    },
    imageAlignment: {
      type: String,
      required: false,
      validator(value) {
        return useCustomValidator(["right", "left", "full"], value);
      },
    },
  },

  setup(props) {
    const alignment = computed(() => ({
      "float-right md:max-w-md xl:max-w-lg": props.imageAlignment === "right",
      "float-left md:max-w-md xl:max-w-lg": props.imageAlignment === "left",
    }));

    return {
      alignment,
    };
  },
};
</script>
